import { combineReducers } from 'redux';

import appReducer from './App/reducers';
import proFormReducer from './SubmissionPro/reducers';
import adminFormReducer from './SubmissionAdmin/reducers';
import leadsReducer from './Leads/reducers';
import projectReducer from './Projects/reducers';
import leadSettingsReducer from './Settings/Leads/reducers';
import projectSettingsReducer from './Settings/Projects/reducers';
import quoteSettingsReducer from './Settings/Quotes/reducers';
import invoiceSettingsReducer from './Settings/Invoices/reducers';
import projectItemReducer from './ProjectTools/Project/reducers';
import notesReducer from './ProjectTools/Notes/reducers';
import noteReducer from './ProjectTools/Notes/Note/reducers';
import billingReducer from './Billing/reducers';
import eventsReducer from './Events/reducers';

const rootReducer = combineReducers({
  global: appReducer,
  proForm: proFormReducer,
  adminForm: adminFormReducer,
  leads: leadsReducer,
  projects: projectReducer,
  settings: combineReducers({
    leadSettings: leadSettingsReducer,
    projectSettings: projectSettingsReducer,
    quoteSettings: quoteSettingsReducer,
    invoiceSettings: invoiceSettingsReducer,
  }),
  projectTools: combineReducers({ project: projectItemReducer, notes: notesReducer, note: noteReducer }),
  billing: billingReducer,
  events: eventsReducer,
});

export default rootReducer;
